<div class="scan-tag-input" [class.is-disabled]="disabled">
  <div class="inner">
    <div class="inner-input">
      <input
        #input
        [name]="name"
        [value]="value"
        [placeholder]="'scan.placeHolder' | translate"
        [readonly]="disabled"
        [disabled]="disabled || loading"
        [attr.type]="type"
        [attr.pattern]="pattern"
        [attr.inputmode]="inputmode"
        (paste)="onPaste($event)"
        (focus)="onFocus($event)"
        (blur)="onBlur($event)"
        (change)="inputChange($event)"
        (keydown)="keyDown($event)"
      />
    </div>
    <span
      class="input-camera"
      [class.disabled]="!enableCamera"
      (mousedown)="openCameraDialog($event)"
    >
      <mat-icon>photo_camera</mat-icon>
    </span>
    <span
      role="button"
      class="btn input-clear"
      [class.disabled]="disabled"
      (mousedown)="onClear()"
    >
      <div class="icon">
        @if (!loading) {
          <mat-icon>clear</mat-icon>
        } @else {
          <mat-spinner diameter="24"></mat-spinner>
        }
      </div>
    </span>
  </div>
</div>
